import { render, staticRenderFns } from "./BattleDetails.vue?vue&type=template&id=83a382f8&scoped=true"
import script from "./BattleDetails.vue?vue&type=script&lang=js"
export * from "./BattleDetails.vue?vue&type=script&lang=js"
import style0 from "./BattleDetails.vue?vue&type=style&index=0&id=83a382f8&prod&lang=scss&scoped=true"
import style1 from "./BattleDetails.vue?vue&type=style&index=1&id=83a382f8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83a382f8",
  null
  
)

export default component.exports